import { HttpLink } from '@apollo/client/core';
import StorageService from '@/services/StorageService';

const customFetch = (uri, options) => {
  const JSON_BODY = JSON.parse(options.body);
  options.body = JSON.stringify({ // eslint-disable-line no-param-reassign
    ...JSON_BODY,
    variables: {
      ...JSON_BODY.variables,
      $cityId: +StorageService.get('city.id') || 0,
      $languageId: +StorageService.get('locale.id') || 1,
    },
  });

  return fetch(uri, options);
};

export default new HttpLink({ uri: process.env.VUE_APP_GRAPHQL_ENDPOINT, fetch: customFetch, credentials: 'include' });
